import axios from 'axios'

export default {
    namespaced: true,
    state: {
        topics: [],
        subtopics: [],
        loading_subtopics: false,
        processing: false,
        selected_topic: {
            id: undefined,
            tema: undefined,
        },
    },
    getters: {
        getTopics(state){
            return state.topics;
        },
        getSubTopics(state){
            return state.subtopics;
        },
        isLoadingSubtopics(state){
            return state.loading_subtopics;
        },
        isProcessing(state){
            return state.processing;
        },
        getSelectedtopic(state){
            return state.selected_topic
        }
    },
    mutations: {
        setTopics(state, topics){
            if(topics.length === 0){
                state.topics = [];
                return;
            }
            state.topics = topics;
        },
        setSubTopics(state, subtopics){
            if(subtopics.length === 0){
                state.subtopics = [];
                return;
            }
            state.subtopics = subtopics;
        },
        setLoadingSubtopics(state, loading_subtopics){
            state.loading_subtopics = loading_subtopics;
        },
        setProcessing(state, processing){
            state.processing = processing;
        },
        setSelectedtopic(state, selected_topic){
            state.selected_topic = selected_topic;
        }

    },
    actions: {
        loadTopicsFromServer(context){
            return new Promise((resolve, reject) => {
                axios.get('/auth/topics/list').then(response => {
                    if (response.data.status === 'success') {
                        context.commit('setTopics', response.data.topics);
                    }
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        loadSubTopicsFromServer(context, topic_id){
            context.commit('setLoadingSubtopics', true);
            return new Promise((resolve, reject) => {
                axios.get('/auth/subtopics/list/' + topic_id).then(response => {
                    if (response.data.status === 'success') {
                        context.commit('setSubTopics', response.data.subtopics);
                    }
                    resolve(response);
                }).catch(error => {
                    reject(error);
                }).finally(()=> {
                    context.commit('setLoadingSubtopics', false);
                });

            });
        },
        deleteTopicInServer(context, topic_id){
            return new Promise((resolve, reject) => {
                context.commit('setProcessing', true);
                axios.delete('/auth/topics/delete/' + topic_id).then(response => {
                    if (response.data.status === 'success') {
                        context.dispatch('loadTopicsFromServer');
                        Vue.prototype.$eventHub.$emit('showToastNotification', response.data);
                    }
                    resolve(response);
                }).catch(error => {
                    reject(error);
                }).finally(()=> {
                    context.commit('setProcessing', false);
                });;
            });
        },
        deleteSubTopicInServer(context, payload){
            return new Promise((resolve, reject) => {
                context.commit('setProcessing', true);
                axios.delete('/auth/subtopics/delete/' + payload.subtopic_id).then(response => {
                    if (response.data.status === 'success') {
                        context.dispatch('loadSubTopicsFromServer', payload.topic_id);
                        Vue.prototype.$eventHub.$emit('showToastNotification', response.data);
                    }
                    resolve(response);
                }).catch(error => {
                    reject(error);
                }).finally(()=> {
                    context.commit('setProcessing', false);
                });;
            });
        },
        saveSubtopicInServer(context, payload) {
            return new Promise((resolve, reject) => {
                context.commit('setProcessing', true);
                let data = {
                    subtopic: payload.subtopic,
                    topic_id: payload.topic.id,
                }
                axios.post('/auth/subtopics/save', data).then(response => {
                    if (response.data.status === 'success') {
                        context.dispatch('loadSubTopicsFromServer', payload.topic.id);
                        context.commit('setSelectedtopic', payload.topic)
                        Vue.prototype.$eventHub.$emit('showToastNotification', response.data);
                    }
                    resolve(response);
                }).catch(error => {
                    reject(error);
                }).finally(()=> {
                    context.commit('setProcessing', false);
                });;
            });
        },
        updateSubtopicInServer(context, payload) {
            return new Promise((resolve, reject) => {
                context.commit('setProcessing', true);
                let data = {
                    subtopic: payload.subtopic,
                    topic_id: payload.topic.id,
                }
                axios.post('/auth/subtopics/update/' + payload.subtopic_id, data).then(response => {
                    if (response.data.status === 'success') {
                        context.dispatch('loadSubTopicsFromServer', payload.topic.id);
                        context.commit('setSelectedtopic', payload.topic)
                        Vue.prototype.$eventHub.$emit('showToastNotification', response.data);
                    }
                    resolve(response);
                }).catch(error => {
                    reject(error);
                }).finally(()=> {
                    context.commit('setProcessing', false);
                });;
            });
        },
        saveTopicInServer(context, payload) {
            return new Promise((resolve, reject) => {
                context.commit('setProcessing', true);
                let data = {
                    topic: payload.topic,
                }
                axios.post('/auth/topics/save', data).then(response => {
                    if (response.data.status === 'success') {
                        let topic = response.data.topic;
                        context.dispatch('loadTopicsFromServer');
                        context.commit('setSelectedtopic', {
                            id: topic.id,
                            tema: topic.tema,
                        });
                        context.dispatch('loadSubTopicsFromServer', topic.id);
                        Vue.prototype.$eventHub.$emit('showToastNotification', response.data);
                    }
                    resolve(response);
                }).catch(error => {
                    reject(error);
                }).finally(()=> {
                    context.commit('setProcessing', false);
                });;
            });
        },
        updateTopicInServer(context, payload) {
            return new Promise((resolve, reject) => {
                context.commit('setProcessing', true);
                let data = {
                    topic: payload.topic,
                }
                axios.post('/auth/topics/update/' + payload.topic_id, data).then(response => {
                    if (response.data.status === 'success') {
                        let topic = response.data.topic;
                        context.dispatch('loadTopicsFromServer');
                        context.commit('setSelectedtopic', {
                            id: topic.id,
                            tema: topic.tema,
                        });
                        context.dispatch('loadSubTopicsFromServer', topic.id);
                        Vue.prototype.$eventHub.$emit('showToastNotification', response.data);
                    }
                    resolve(response);
                }).catch(error => {
                    reject(error);
                }).finally(()=> {
                    context.commit('setProcessing', false);
                });
            });
        }

    }
}